import { CONSENT_VERSION } from '@geo-admin/shared/contract/api/signup.ts';
import { BRAND, COMPANY } from '../../lib/company.ts';
import type { LegalDoc } from '../types.ts';

export const privacyPolicy: LegalDoc = {
  title: '개인정보처리방침',
  effectiveDate: CONSENT_VERSION,
  blocks: [
    {
      kind: 'p',
      text: `${COMPANY.name}(이하 "회사")는 ${BRAND.name} 서비스 이용자의 개인정보를 중요하게 생각하며, 「개인정보 보호법」 등 관련 법령을 준수합니다. 본 방침은 회사가 어떤 정보를 어떤 목적으로 처리하고 얼마나 보관하는지를 설명합니다.`,
    },

    { kind: 'h2', text: '1. 수집하는 개인정보와 수집 방법' },
    { kind: 'p', text: '회사는 서비스 제공에 필요한 최소한의 정보만 수집합니다.' },
    {
      kind: 'table',
      head: ['구분', '항목', '수집 시점'],
      rows: [
        ['필수', '이메일 주소, 비밀번호(복호화할 수 없는 형태로 저장), 업체명, 대표자명, 휴대폰 번호', '가입 신청'],
        ['필수', '희망 질문, 추가 문의사항', '가입 신청'],
        ['필수', '카드 소유자 이름, 카드사, 카드번호 끝 4자리, 유효기간', '구독 결제 카드 등록'],
        ['선택', '결제 알림을 받을 휴대폰 번호', '구독 결제 카드 등록'],
        ['자동', '결제 기록(금액, 일시, 주문번호, 승인번호, 결과)', '구독 결제 시'],
        ['자동', '접속 IP 주소, 접속 시각, 문자 발송·확인 기록', '서비스 이용 시'],
      ],
    },
    {
      kind: 'p',
      text: '회사는 가입 시 입력한 휴대폰 번호로 문자를 보내 그 번호를 사용할 수 있는지 확인합니다. 이 절차는 이용자 개인의 신원을 확인하는 절차가 아니며, 주민등록번호 등 고유식별정보는 수집하지 않습니다.',
    },
    {
      kind: 'p',
      text: '구독 결제 카드를 등록할 때 입력하는 카드번호 전체, 생년월일(법인은 사업자등록번호), 카드 비밀번호 앞 2자리는 결제대행사(주식회사 페이업)로 바로 전달되며 회사는 저장하지 않습니다. 회사는 결제대행사가 발급한 자동결제용 키를 암호화해 보관하고, 카드번호는 끝 4자리만 보관합니다.',
    },

    { kind: 'h2', text: '2. 개인정보의 처리 목적' },
    {
      kind: 'ol',
      items: [
        '회원 식별과 로그인, 가입 신청의 승인 여부 판단',
        '보고서 발송 등 서비스 제공과 관련한 안내·연락',
        '구독 이용료 결제와 매월 자동결제, 결제 결과·실패 안내, 결제 취소와 환불',
        '부정 가입·문자 발송 남용 방지 및 이에 필요한 기록 보존',
        '문의 대응 및 서비스 개선',
      ],
    },

    { kind: 'h2', text: '3. 보유 기간' },
    {
      kind: 'table',
      head: ['항목', '보유 기간'],
      rows: [
        ['회원 계정 정보(이메일·업체명·대표자명·휴대폰 번호)', '탈퇴 시까지. 탈퇴 즉시 파기'],
        ['휴대폰 번호 확인 기록(발송·시도 횟수)', '생성 후 24시간. 발송 남용 방지를 위한 최소 기간'],
        ['접속 IP·접속 기록', '3개월'],
        [
          '결제 카드 정보(카드 소유자 이름·카드사·끝 4자리·유효기간·알림 휴대폰 번호·자동결제용 키)',
          '카드를 삭제하거나 탈퇴하면 자동결제를 해지하고 결제에 더 쓰지 않습니다. 결제 기록에 딸린 항목은 아래 결제 기록과 함께 보관합니다',
        ],
        ['대금 결제와 서비스 공급에 관한 기록', '5년(「전자상거래 등에서의 소비자보호에 관한 법률」)'],
        ['관련 법령에 따라 보존이 필요한 기록', '해당 법령이 정한 기간'],
      ],
    },
    {
      kind: 'p',
      text: '수집이 완료된 AI 답변 측정 기록은 특정 개인을 알아볼 수 없는 통계·지표 이력이므로 탈퇴 후에도 보존될 수 있습니다.',
    },

    { kind: 'h2', text: '4. 개인정보의 처리위탁' },
    { kind: 'p', text: '회사는 서비스 제공을 위해 아래와 같이 업무를 위탁하고 있습니다.' },
    {
      kind: 'table',
      head: ['수탁자', '위탁 업무', '비고'],
      rows: [
        ['NHN 클라우드 주식회사', '휴대폰 번호 확인 문자 발송', '휴대폰 번호'],
        ['주식회사 페이업', '신용카드 결제, 자동결제 키 발급·관리, 결제 취소와 환불', '카드 정보·결제 정보'],
        ['Google Cloud (Google LLC)', '서버·데이터베이스 운영', '대한민국(서울) 리전에 저장'],
      ],
    },
    {
      kind: 'p',
      text: '회사는 위탁계약 시 개인정보의 안전한 관리에 관한 사항을 문서로 정하고, 수탁자가 이를 준수하는지 감독합니다.',
    },

    { kind: 'h2', text: '5. 제3자 제공' },
    {
      kind: 'p',
      text: '회사는 이용자의 개인정보를 제3자에게 제공하지 않습니다. 다만 법령에 따라 수사기관 등이 적법한 절차로 요구하는 경우에는 그에 따릅니다.',
    },

    { kind: 'h2', text: '6. 파기 절차와 방법' },
    {
      kind: 'ol',
      items: [
        '이용자가 서비스 화면에서 탈퇴하면 계정의 이메일·대표자명·휴대폰 번호는 즉시 복구할 수 없는 형태로 처리되고 계정은 비활성화됩니다.',
        '보유 기간이 지난 기록은 자동화된 정리 작업으로 삭제됩니다.',
        '전자적 파일은 복구할 수 없는 방법으로 삭제하고, 출력물이 있는 경우 파쇄합니다.',
      ],
    },

    { kind: 'h2', text: '7. 이용자의 권리와 행사 방법' },
    {
      kind: 'ol',
      items: [
        '이용자는 언제든지 자신의 개인정보 열람·정정·삭제·처리정지를 요구할 수 있습니다.',
        '탈퇴는 서비스 화면에서 직접 할 수 있으며, 그 밖의 요구는 아래 연락처로 접수합니다.',
        '회사는 요구를 받은 날부터 10일 이내에 조치하고 결과를 알립니다.',
      ],
    },

    { kind: 'h2', text: '8. 안전성 확보 조치' },
    {
      kind: 'ol',
      items: [
        '비밀번호는 복호화할 수 없는 해시로만 저장합니다.',
        '개인정보 접근 권한은 업무상 필요한 최소 인원으로 제한합니다.',
        '전송 구간은 암호화(HTTPS)하며, 데이터베이스는 외부에서 직접 접근할 수 없도록 차단합니다.',
        '문자 발송·로그인 시도에 횟수 제한을 두어 남용을 차단합니다.',
      ],
    },

    { kind: 'h2', text: '9. 개인정보 보호책임자' },
    {
      kind: 'ul',
      items: [
        `개인정보 보호책임자 ${COMPANY.privacyOfficer}`,
        `연락처 ${COMPANY.tel}`,
        `이메일 ${COMPANY.email}`,
        `주소 ${COMPANY.address}`,
      ],
    },
    {
      kind: 'p',
      text: '개인정보 침해에 대한 신고·상담은 개인정보침해신고센터(privacy.kisa.or.kr, 118), 개인정보 분쟁조정위원회(kopico.go.kr, 1833-6972), 대검찰청 사이버수사과(1301), 경찰청 사이버수사국(ecrm.police.go.kr, 182)에 할 수 있습니다.',
    },

    { kind: 'h2', text: '10. 방침의 변경' },
    {
      kind: 'p',
      text: '본 방침을 변경하는 경우 변경 사유와 시행일을 서비스 화면에 게시하고, 이용자에게 불리한 변경은 시행일 30일 전부터 알립니다.',
    },
    { kind: 'p', text: `시행일: ${CONSENT_VERSION}` },
  ],
};
